import { ClockCounterClockwiseIcon, SealCheckIcon, WarningIcon } from '@phosphor-icons/react/dist/ssr';
import Link from 'next/link';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Separator, Text } from '@/shared/ui/core';
import { CoinsIcon, QuestionIcon, SignOutIcon, UserIcon, WalletIcon } from '@phosphor-icons/react/ssr';
import {
    ACCOUNT_PATHNAME, BILLING_PATHNAME, HISTORY_PATHNAME, REPORT_PATHNAME, SUBSCRIPTION_PATHNAME, SUPPORT_PATHNAME, VERIFICATION_PATHNAME,
} from '@/shared/constants/pathnames';
import { LogoutButton } from '@/features/auth/logout-button';
import styles from './user-menu.module.scss';


const LINKS = [
    { href: VERIFICATION_PATHNAME, icon: <SealCheckIcon size={ 24 }/>,             label: 'Verification' },
    { href: HISTORY_PATHNAME,      icon: <ClockCounterClockwiseIcon size={ 24 }/>, label: 'History' },
    { href: REPORT_PATHNAME,       icon: <WarningIcon size={ 24 }/>,               label: 'Report' },
    { href: ACCOUNT_PATHNAME,      icon: <UserIcon size={ 24 }/>,                  label: 'Account' },
    { href: SUBSCRIPTION_PATHNAME, icon: <WalletIcon size={ 24 }/>,                label: 'Subscription' },
    { href: BILLING_PATHNAME,      icon: <CoinsIcon size={ 24 }/>,                 label: 'Billing & payments' },
    { href: SUPPORT_PATHNAME,      icon: <QuestionIcon size={ 24 }/>,              label: 'Support' },
];


export function UserMenu () {
    return (
        <DropdownMenu.Portal>
            <DropdownMenu.Content
                className={ styles.root }
                align="end"
                sideOffset={ 0 }
                alignOffset={ -8 }
            >
                {
                    LINKS.map(({ href, icon, label }) => {
                        return (
                            <DropdownMenu.Item
                                key={ href }
                                asChild
                                className={ styles.item }
                            >
                                <Link
                                    href={ href }
                                    className={ styles.link }
                                >
                                    { icon }

                                    <Text
                                        tone="primary"
                                        weight="medium"
                                        className={ styles.label }
                                    >
                                        { label }
                                    </Text>
                                </Link>
                            </DropdownMenu.Item>
                        );
                    })
                }

                <Separator className={ styles.separator }/>


                <LogoutButton
                    className={ styles.link }
                    leftIcon={ <SignOutIcon size={ 24 }/> }
                >
                    <Text
                        tone="primary"
                        weight="medium"
                        className={ styles.label }
                    >
                        Logout
                    </Text>
                </LogoutButton>
            </DropdownMenu.Content>
        </DropdownMenu.Portal>
    );
}
